import { useLocation, useNavigate } from "react-router-dom";

function useTableEntityNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const goToItem = (id: number | string, itemUrl: (id: string | number) => string, replace: boolean) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("subpage", "true");

    navigate(`${itemUrl!(id)}?${searchParams.toString()}`, {
      state: { background: location, preserveSearch: true },
      replace: replace,
    });
  };

  const isTableEntityNavigation = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("subpage");
  };

  return { goToItem, isTableEntityNavigation };
}

export default useTableEntityNavigation;
